export default __webpack_public_path__ + "static/media/default_white@3x.ac0cbc85.webp";